import React, { Component } from 'react';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import Input from 'components/shared/input/Input';
import { Field, reduxForm } from 'redux-form';
import './AddVendorInvoiceForm.css';
import uploadSvg from 'images/upload.svg';
import Dropzone from 'react-dropzone';
import DocumentLink from 'components/shared/document/DocumentLink';
import removeSvg from 'images/remove.svg';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import { todayValidation } from 'services/utils/date-util';
import FormDropDown from 'components/shared/form/FormDropDown';

class AddVendorInvoiceForm extends Component {
  renderDatePicker = (props) => {
    return (
      <DatetimePicker
        valid={!props.meta.error || !props.meta.submitFailed}
        value={props.input.value}
        onChange={(value) => props.input.onChange(value)}
        {...props}
      />
    );
  };

  renderDocument = (props) => {
    if (props.input.value === '') {
      const isValid = !props.meta.error || !props.meta.submitFailed;
      return (
        <Dropzone
          accept="application/pdf, .doc, .docx, .xls, .xlsx"
          className={`dropzone-container${
            !isValid ? ' dropzone-with-error' : ''
          }`}
          multiple={false}
          onDrop={(files) => props.input.onChange(files[0])}
        >
          <span>Please drag and drop any file into this area</span>
          <img src={uploadSvg} alt="upload" />
        </Dropzone>
      );
    }
    return (
      <div className="file-viewer">
        <DocumentLink
          file={props.input.value}
          showIcon={false}
          showLink={true}
        />
        <img
          src={removeSvg}
          alt="remove"
          onClick={() => props.input.onChange('')}
        />
      </div>
    );
  };

  renderInput = (props) => {
    return (
      <Input
        valid={!props.meta.error || !props.meta.submitFailed}
        value={props.input.value}
        onChange={(value) => props.input.onChange(value)}
        {...props}
      />
    );
  };

  render() {
    return (
      <div className="add-vendor-invoice-form">
        <Form horizontal onSubmit={this.props.handleSubmit}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Task
            </Col>
            <Col sm={9}>
              <Field
                component={FormDropDown}
                name="taskId"
                options={this.props.tasks.map((task) => ({
                  value: task.id,
                  label: `${task.number} - ${task.name}`,
                }))}
                placeholder="Task"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Vendor Name
            </Col>
            <Col sm={9}>
              <Field
                component={this.renderInput}
                name="vendorName"
                placeholder="Vendor Name"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Due Date
            </Col>
            <Col sm={9}>
              <Field
                component={this.renderDatePicker}
                isValidDate={todayValidation}
                name="dueDate"
                placeholder="Due Date"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Amount
            </Col>
            <Col sm={9}>
              <Field
                component={this.renderInput}
                name="cost"
                placeholder="Amount"
                type="number"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Document
            </Col>
            <Col sm={9}>
              <Field
                component={this.renderDocument}
                name="document"
                placeholder="Document"
              />
            </Col>
          </FormGroup>
          {this.props.invalid && this.props.submitFailed && (
            <div className="invalid-message">
              The outlined inputs should be added in order to add an Invoice.
            </div>
          )}
          <FormGroup className="button-container">
            <Col sm={12}>
              <input
                className="btn button button-orange"
                type="submit"
                value="Create"
              />
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  if (!values.taskId) {
    errors.taskId = 'Required';
  }
  if (!values.vendorName) {
    errors.vendorName = 'Required';
  }
  if (!values.dueDate) {
    errors.dueDate = 'Required';
  }
  if (!values.cost) {
    errors.cost = 'Required';
  }
  if (!values.document) {
    errors.document = 'Required';
  }
  return errors;
}

export default reduxForm({
  form: 'AddVendorInvoiceForm',
  validate,
})(AddVendorInvoiceForm);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/vendor-invoices/AddVendorInvoiceForm.js